import { render, staticRenderFns } from "./wechatPay.vue?vue&type=template&id=af3a7c70&scoped=true"
import script from "./wechatPay.vue?vue&type=script&lang=js"
export * from "./wechatPay.vue?vue&type=script&lang=js"
import style0 from "./wechatPay.vue?vue&type=style&index=0&id=af3a7c70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3a7c70",
  null
  
)

export default component.exports